import { HOME_OFFERS_LIST} from "../../../redux/contants";

// eslint-disable-next-line import/prefer-default-export
export const getHomeOffers = (data) => ({
    type: HOME_OFFERS_LIST,
    payload: data
});
